import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);
    const userService: UserService = inject(UserService);
    const authService: AuthService = inject(AuthService);
    const configService: FuseConfigService = inject(FuseConfigService);

    // Check the authentication status
    return authService.check().pipe(
        switchMap((authenticated) =>
        {
            // If the user is not authenticated...
            if ( !authenticated )
            {
                // Redirect to the sign-in page with a redirectUrl param
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                return of(urlTree);
            }

            if(route.data.UserType && configService.global.settings.userType != route.data.UserType)
            {           
                authService.signOut();
                // Redirect to the sign-in page with a redirectUrl param
                const urlTree = router.parseUrl('sign-in');

                return of(urlTree);
            }

            // Allow the access
            return of(true);
        }),
    );
};
